import React from "react";
import Helper from "../classes/Helper";
import styled from "styled-components";

const SentenceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-content: center;
    width: 100%;
`;

    const Sentence = styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        top: 0;
        padding: 0;
        margin: 0;
        margin-bottom: 10px;
        cursor: pointer;
        width: 100%;
        border-radius: 5px;
        transition: box-shadow 0.3s;
        margin-bottom: 50px;

        &:hover{
            -webkit-box-shadow: inset 0px 0px 6px 0px rgba(0, 94, 88, 1);
            -moz-box-shadow: inset 0px 0px 6px 0px rgba(0, 94, 88, 1);
            box-shadow: inset 0px 0px 6px 0px rgba(0, 94, 88, 1);   
        }
    `;

export default class SentencesBank extends React.PureComponent{
    constructor(props){
        super(props);
        this.state = {
            sentences: [],
            maxLines: undefined
        }
    }

    componentDidMount(){
        this.fetchData();
    }

    fetchData = (e) => {
        let lines = Helper.getLinesCount(this.props.object._getTextJSONText(this.props.selectedLanguage));
        let form = new FormData();
        form.append('id_feast', '%');
        form.append('lines', lines);

        fetch(`/modules/new_creator/ajax/get_sentences.php`, {
            method: 'POST',
            body: form
        })
        .then(data => data.json())
        .then(json => {
            if(json)
                this.setState({
                    sentences: json
                })
        });
    }

    onClickSentence = (e) => {
        let sentence = this.state.sentences[Number(e.currentTarget.getAttribute('data-index'))];
        if(this.props.authorObject){
            this.props.authorObject._setTextJSON(sentence.author, this.props.selectedLanguage);
            this.props.authorObject.fitText(this.props.selectedLanguage);
        }
        this.props.object._setTextJSON(sentence.sentence, this.props.selectedLanguage);
        this.props.object.fitText(this.props.selectedLanguage);
        this.props.closeModal(e);
    }

    render(){
        const { sentences } = this.state;
        const content = sentences?.map((value, key) => {
            return(
                <Sentence
                    key={key}
                    data-index={key}
                    onClick={this.onClickSentence}
                >
                {
                    value.sentence.split('\n').map((item) => {
                        return <span>{item}<br/></span>
                    })
                }
                </Sentence>
            );
        });
        return(
            <SentenceWrapper>
                { content }
            </SentenceWrapper>
        )
    }
}